import Layout from "@/components/Layout";
import HeroSection from "@/components/HeroSection";
import ValuePropsGrid from "@/components/ValuePropsGrid";
import HowItWorks from "@/components/HowItWorks";
import GivingBackTeaser from "@/components/GivingBackTeaser";
import { useSEO } from "@/hooks/useSEO";

const Index = () => {
  useSEO({
    title: "Hintsly — Give the Gift They'll Actually Love | Free Australian Gift Registry",
    description: "Tired of fake smiles and unwanted gifts? Hintsly is a free Australian wishlist that works with any store. Build your list, share the hint, and get gifts you'll genuinely love.",
    canonical: "https://hintsly.com.au/",
  });

  return (
    <Layout>
      <HeroSection />
      <ValuePropsGrid />
      <HowItWorks />
      <GivingBackTeaser />
    </Layout>
  );
};

export default Index;